const restructureObjects = (arr) => {
  return arr.map((itemArray) => ({
    ...itemArray,
    label: itemArray.name,
    value: itemArray.id,
  }));
};

export default restructureObjects;
